import MasterProductCURModule from "@/modules/MasterProductCUR";

function ViewMasterProductPage() {
  return <MasterProductCURModule type="view" />;
}

export default ViewMasterProductPage;
